"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

function insertCharacter(editorState, start, end, char) {
  var prevValue = editorState.list.value[start];
  var nextValue = editorState.list.value[end + 1];
  var entity;

  if (nextValue != null && nextValue.type == null && prevValue != null && prevValue.type == null && prevValue.entity === nextValue.entity) {
    entity = prevValue.entity;
  }

  var newEditorState = editorState.change({
    isBoundary: editorState.lastChangeType !== constants_1.COMMAND.INSERT_CHARACTER,
    type: constants_1.COMMAND.INSERT_CHARACTER,
    start: start,
    end: end,
    value: [{
      char: char,
      styles: editorState.currentStyles,
      entity: entity
    }]
  }).change({
    type: constants_1.COMMAND.INSERT_CHARACTER,
    start: start + 1,
    end: start + 1
  });
  return newEditorState;
}

exports.default = insertCharacter;